export const apiDomain = (process.env.NODE_ENV === 'production') ? '//bildersicht.m-texte.de' : 'http://localhost:8080';